// Normalisierung fuer Freitext-Suche in Auswahllisten.
//
// Nutzer tippen "malaga", "espana", "zurich" - die Daten heissen "Málaga",
// "España", "Zürich". Ein reines toLowerCase().includes() findet das nicht:
// "españa".includes("espana") ist false. In der Ziel-Auswahl fuehrte das dazu,
// dass passende Hotels aus dem Ergebnis fielen und stattdessen eine alphabetische
// Liste aller Teiltreffer erschien.
//
// Gleiches Verhalten wie in AirportDropdown/AirportPopUp, nur an einer Stelle.

/** Kleinschreibung, Diakritika entfernt, deutsche Umlaute/ß ausgeschrieben. */
export const normalizeForSearch = (s = "") =>
  String(s)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/ü/g, "u")
    .replace(/ß/g, "ss");

/** Enthaelt `text` den Teilstring `needle` - unabhaengig von Akzenten? */
export const includesNormalized = (text, needle) =>
  normalizeForSearch(text).includes(normalizeForSearch(needle));

/**
 * Enthaelt `text` ALLE Woerter aus `words`?
 * Leere Wortliste = kein Filter, also true.
 */
export const matchesAllWords = (text, words) => {
  if (!words || words.length === 0) return true;
  const haystack = normalizeForSearch(text);
  return words.every((w) => haystack.includes(normalizeForSearch(w)));
};

/** Enthaelt `text` MINDESTENS EIN Wort aus `words`? */
export const matchesAnyWord = (text, words) => {
  if (!words || words.length === 0) return false;
  const haystack = normalizeForSearch(text);
  return words.some((w) => haystack.includes(normalizeForSearch(w)));
};

/** Sucheingabe in Woerter zerlegen (leere Teile fallen weg). */
export const toSearchWords = (input = "") =>
  String(input)
    .split(/\s+/)
    .filter((w) => w.length > 0);
